export default __webpack_public_path__ + "static/media/porcelain-pavers-indoor-outdoor.2b3c3aaf.jpg";